import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useMatchMedia } from 'utils/matchMedia/hooks'

import mq from 'utils/matchMedia/styles/MatchMediaQueries.module.scss'

export const useScreenSize = (): {
	showAsSmall: boolean
	showAsMedium: boolean
	showAsMediumOrSmall: boolean
} => {
	const { isMobile } = useMasterData()
	const [isSmall, isMedium] = useMatchMedia([mq.issmall, mq.ismedium])
	const showAsSmall = isMobile || (!isMobile && isSmall)
	const showAsMedium = isMobile || (!isMobile && isMedium)
	return {
		showAsSmall,
		showAsMedium,
		showAsMediumOrSmall: showAsSmall || showAsMedium,
	}
}
